import React from "react";
import { connect } from "react-redux";
import HeaderPlanMovilidad from "../Util/Header";
import AccordionAdministracion from "./accordionAdministracion";
import Loading from "../Util/Loading";
import { getListadoPlanesMovilidad } from "../Planes/actions";
import { push } from "connected-react-router";
import { checkAccess, ids, realCheckAccess } from "../../../helpers/rolAccess";
import { paths } from "../../../config/routes";

class Administracion extends React.Component {

  constructor(props) {
    super(props);
    if (this.props.sucursalId !== "" && this.props.companyId !== "") {
      this.props.dispatch(getListadoPlanesMovilidad(this.props.companyId, this.props.sucursalId, null));
    }
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.companyId !== this.props.companyId) {
      this.props.dispatch(push(paths.root))
    }
  }

  render() {
    return (
      <div id="administracion">
        {this.props.isLoading && <Loading />}
        <HeaderPlanMovilidad />
        <section className="col-sm-12">
          {
            (this.props.sucursalId === "") ?
              <div className="row">
                <div className="col-md-12 text-center">
                  <h5>Selecciona un centro de trabajo para acceder a la opción de administración.</h5>
                </div>
              </div>
              :
              (this.props.idplanMovilidad || this.props.planesMovilidad.length > 0) ?
                <div className="position-relative overflow-hidden col-sm-12 text-center">
                  <div className="col-sm-12 text-center">
                    <span className="PM-section-title">Administración  de Planes de movilidad</span>
                  </div>
                  <div className="col-sm-12 text-center">
                    <h5>En esta sección podrás cambiar el responsable del plan.</h5>
                  </div>
                  <div className="col-sm-12 text-left">
                    {
                      this.props.estadoProceso === 0?
                        <AccordionAdministracion
                          planes={this.props.planesMovilidad}
                          actual={[]}
                        />
                      :
                        <AccordionAdministracion
                          planes={this.props.planesMovilidad}
                          actual={[{
                            idplanMovilidad: this.props.idplanMovilidad,
                            estadoProceso: this.props.estadoProceso,
                            estadoPlan: this.props.estadoPlan,
                            estadoEjecucion: this.props.estadoEjecucion,
                            fechaCreacion: this.props.fechaCreacion,
                            nombreusuario: this.props.nombreusuario,
                            rutusuario: this.props.rutusuario,
                            idcentro: this.props.sucursalId,
                          }]}
                        />
                    }
                  </div>
                </div>
                :
                <div className="position-relative overflow-hidden col-sm-12 text-center">
                  <h2>El centro seleccionado aún no tiene ningún proceso de planes de movilidad</h2>
                </div>
          }
        </section>
        <div className="PM-footer">&nbsp;</div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  sucursalId: state.global.sucursalId,
  companyId: state.global.companyId,
  idplanMovilidad: state.planMovilidad.idplanMovilidad,
  planesMovilidad: state.planMovilidad.planesMovilidad,
  estadoProceso: state.planMovilidad.estadoProceso,
  estadoPlan: state.planMovilidad.estadoPlan,
  estadoEjecucion: state.planMovilidad.estadoEjecucion,
  fechaCreacion: state.planMovilidad.fechaCreacion,
  nombreusuario: state.planMovilidad.nombreusuario,
  rutusuario: state.planMovilidad.rutusuario,
  isLoading: state.planMovilidad.isLoading,
  userAccessIds: state.global.userAccessIds,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(Administracion);
